import type { Dictionary } from './en';

const de: Dictionary = {
  brand: 'KommGutHeim',
  meta: {
    titleDefault: 'KommGutHeim',
    titleTravelling: 'KommGutHeim – Begleite {name} auf dem Weg',
    titleArrived: 'KommGutHeim – {name} ist gut angekommen',
    titleEmergency: 'KommGutHeim – {name} hat einen Notruf ausgelöst',
  },
  social: {
    titleDefault: 'Ich teile meinen Standort',
    descriptionDefault: 'Begleite mich, bis ich sicher angekommen bin.',
    titleTravelling: '{name} ist unterwegs',
    descriptionTravelling: 'Begleite {name} live bis zur sicheren Ankunft.',
    titleArrived: '{name} ist gut angekommen',
    descriptionArrived: 'Der Weg ist geschafft.',
  },
  status: {
    onTheWay: '{name} ist unterwegs',
    onTheWayTo: '{name} ist unterwegs nach {destination}',
    arrived: '{name} ist gut angekommen um {time}',
    arrivedNoTime: '{name} ist gut angekommen',
    emergency: '{name} hat einen Notruf ausgelöst',
    titleSubtitle: '{name} ist unterwegs',
  },
  transport: {
    foot: 'zu Fuß',
    running: 'beim Laufen',
    bike: 'mit dem Fahrrad',
    car: 'mit dem Auto',
    motorcycle: 'mit dem Motorrad',
    bus: 'mit dem Bus',
    train: 'mit dem Zug',
    plane: 'mit dem Flugzeug',
    boat: 'mit dem Boot',
    horse: 'zu Pferd',
    detecting: 'wird erkannt …',
  },
  connection: {
    connecting: 'Verbinden',
    live: 'Live',
    stale: 'Signal schwach',
    offline: 'Offline',
  },
  stats: {
    battery: 'Akku',
    speed: 'Geschwindigkeit',
    avgSpeed: 'Ø Geschwindigkeit',
    distance: 'Distanz',
    time: 'Zeit',
    startAddress: 'Start',
    finishAddress: 'Ankunft',
    lastUpdate: 'Vor {seconds} s aktualisiert',
    lastUpdateMin: 'Vor {minutes} Min. aktualisiert',
    justUpdated: 'Gerade aktualisiert',
  },
  welcome: {
    prompt: '{name} hat dich als Begleiter eingeladen.',
    askName: 'Mit welchem Namen möchtest du erscheinen?',
    nameLabel: 'Dein Name',
    save: 'Namen speichern',
    skip: 'Überspringen',
    watchingAs: 'Du schaust mit als {name}',
    setYourName: 'Namen festlegen',
  },
  download: {
    title: 'KommGutHeim laden',
    blurb: 'Teile deine eigenen Fahrten mit Freundinnen und Freunden.',
    ios: 'App Store',
    android: 'Google Play',
    chip: 'App laden',
    chipDismiss: 'Schließen',
    iosCta: 'Aus dem App Store laden',
    androidCta: 'Bei Google Play laden',
    otherCta: 'KommGutHeim laden',
  },
  loading: {
    title: 'Fahrt wird geladen …',
    verifying: 'Begleit-Code wird geprüft …',
    fetching: 'Route wird geladen …',
  },
  empty: {
    notFound: 'Dieser Weg wurde nicht gefunden.',
    noCode: 'Öffne diese Seite mit einem Begleit-Code: {url}',
    error: 'Etwas ist schiefgelaufen: {message}',
  },
  playback: {
    play: 'Weg wiederholen',
    playing: 'Wird abgespielt …',
    pause: 'Pause',
    resume: 'Fortsetzen',
    replay: 'Weg wiederholen',
    pausedAt: 'Pausiert um {time}',
  },
  timeline: {
    title: 'Wegprotokoll',
    close: 'Schließen',
    routeStarted: 'Weg gestartet',
    batteryDrop: 'Akku bei {battery}%',
    stationary: 'Seit {duration} ohne Bewegung',
    stillEnRoute: 'Weiter unterwegs',
    stillEnRouteProgress: 'Weiter unterwegs · {progress}%',
    arrived: 'Angekommen',
    emergency: 'Notruf ausgelöst',
    emergencyAlerted: 'Notruf ausgelöst · {count} Kontakte alarmiert',
    companionJoined: '{name} begleitet jetzt mit',
    companionJoinedUnnamed: 'Eine Begleitung ist dazugekommen',
  },
  emergency: {
    bannerActive: '{name} hat einen Notruf ausgelöst',
    bannerCleared: '{name} hat sich um {time} in Sicherheit gemeldet',
    triggeredAgo: 'vor {relative}',
    lastKnown: 'Letzter bekannter Standort',
    callServices: 'Notruf wählen ({number})',
    copyLocation: 'Standort kopieren',
    openInMaps: 'In Karten öffnen',
    enableAlerts: 'Tippe zum Aktivieren der Tonalarme',
    wrongCountry: 'Falsches Land? Ändern',
  },
  ariaLive: {
    travelling: '{name} ist unterwegs.',
    arrived: '{name} ist gut angekommen.',
    emergency: '{name} hat einen Notruf ausgelöst. Letzter bekannter Standort: {location}.',
  },
};

export default de;
